// Page names from the tracking plan; anything else falls back to its first static segment.
const PLAN_NAMES: Record<string, string> = {
  dashboard: 'home',
  'content-review': 'review_queue',
  preferences: 'brand_dna',
};

export function routeName(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  const section = segments[0] === 'app' ? segments[1] : segments[0];
  if (!section) return segments[0] ?? 'root';
  return PLAN_NAMES[section] ?? section.replace(/-/g, '_');
}
